(function () {
  import('./src')
    .then(({ Agent }) => {
      try {
        // eslint-disable-next-line no-new
        new Agent();
      } catch (e) {
        console.error('error loading web-monitoring agent', e);
      }
    })
    .catch((e) => {
      console.error('error loading src in web-monitoring', e);
    });
})();
